import React from 'react';
import { Router } from '@reach/router';
import { compose, lifecycle } from 'recompose';
import { connect } from './redux/store';
import { LoadingMessage } from '@kineticdata/bundle-common';
import { I18n } from '@kineticdata/react';
import { PageTitle } from './components/shared/PageTitle';
import { Settings } from './components/Settings';
import { Notifications } from './components/notifications/Notifications';
import { Datastore } from './components/datastore/Datastore';
import { Robots } from './components/robots/Robots';
import { Users } from './components/users/Users';
import { Teams } from './components/teams/Teams';
import { SchedulerSettings } from './components/SchedulerSettings';
import { SpaceSettings } from './components/space_settings/SpaceSettings';
import { ApprovalManagement } from './components/approvalmanagement/ApprovalManagement';
import { AdminForms } from './components/admin_forms/AdminForms';
import { actions } from './redux/modules/settingsApp';
import { actions as datastoreActions } from './redux/modules/settingsDatastore';

const AppComponent = props => {
  return props.render({
    main: props.loading ? (
      <LoadingMessage />
    ) : (
      <I18n>
        <main className={`package-layout package-layout--settings`}>
          <PageTitle parts={['Loading...']} />
          {props.errors.size > 0 &&
            props.profile.hasAgreements && (
              <div className="alert alert-danger alert-bar">
                <div className="mb-1">
                  An unexpected error occurred. Not all functionality may be
                  available.
                </div>
                {props.errors
                  .map((e, i) => (
                    <small key={`error-${i}`} className="d-block">
                      {e.message}
                    </small>
                  ))
                  .toJS()}
              </div>
            )}
          <Router>
            <SpaceSettings path="space" />
            <Datastore path="datastore/*" />
            <Robots path="robots/*" />
            <Users path="users/*" />
            <Notifications path="notifications/*" />
            <Teams path="teams/*" />
            <SchedulerSettings path="schedulers/*" />
            <ApprovalManagement path="approvalmanagement/*" />
            <AdminForms path="adminforms/*" />
            <Settings default />
          </Router>
        </main>
      </I18n>
    ),
  });
};

const mapStateToProps = state => ({
  loading: state.settingsApp.loading,
  errors: state.settingsApp.errors,
  profile: state.app.profile,
});

const mapDispatchToProps = {
  fetchForms: datastoreActions.fetchForms,
  fetchAppData: actions.fetchAppDataRequest,
};

const enhance = compose(
  connect(
    mapStateToProps,
    mapDispatchToProps,
  ),
  lifecycle({
    componentDidMount() {
      this.props.fetchAppData();
      this.props.fetchForms();
    },
  }),
);

export const App = enhance(AppComponent);
